/**
 * getting specific inner field value.
 * @param {obj} object (json) - full nested object
 * @param {fieldName} - the specific requested field you want to extract
 * @returns json object of key and specific field value
 */

const bytesToDisplayHelper = (
  bytes,
  isMaxSize = false,
  forceDisplayGB = false
) => {
  const convertedFileSize = {
    size: 0,
    type: null,
  };

  if (bytes >= 1099511627776) {
    //check if need to fixed 1 or 0
    if (forceDisplayGB) {
      convertedFileSize.size = (bytes / 1073741824).toFixed(0);
      convertedFileSize.type = "GB";
    } else {
      const needFixed = bytes % 1099511627776 === 0 ? 0 : 1;
      convertedFileSize.size = (bytes / 1099511627776).toFixed(needFixed);
      convertedFileSize.type = "TB";
    }
  } else if (bytes >= 1073741824) {
    convertedFileSize.size = (bytes / 1073741824).toFixed(isMaxSize ? 0 : 2);
    convertedFileSize.type = "GB";
  } else if (bytes >= 1048576) {
    convertedFileSize.size = (bytes / 1048576).toFixed(1);
    convertedFileSize.type = "MB";
  } else if (bytes >= 1024) {
    convertedFileSize.size = (bytes / 1024).toFixed(0);
    convertedFileSize.type = "KB";
  } else {
    convertedFileSize.size = bytes || 0;
    convertedFileSize.type = " bytes";

    if (!bytes) {
      convertedFileSize.type = "";
    }
  }

  return convertedFileSize;
};

export default bytesToDisplayHelper;
